import { COLORS } from '@btime/constants'
import React from 'react'

import { useShouldHideColors } from './options/_form/PdfOptionsFormHandler'
import Text from './Text'

const LabelValue = ({ label, value, children, plainValue, bold }) => {
  const hideColors = useShouldHideColors()

  const styles = {
    root: {
      paddingTop: 11,
      paddingBottom: 11,
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: hideColors ? COLORS.black + '40' : COLORS.light3,
      width: '100%'
    },
    grid: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
      // marginBottom: !!children ? 6 : 0
    },
    label: {
      flex: 1,
      paddingRight: 18
    },
    value: {
      flex: 1,
      display: plainValue && 'flex',
      justifyContent: plainValue && 'flex-end'
    }
  }

  return (
    <div style={styles.root}>
      <div style={styles.grid}>
        <div style={styles.label}>
          <Text bold>{label}</Text>
        </div>
        <div style={styles.value}>
          {plainValue ? (
            value
          ) : (
            <Text align="right" preLine bold={bold}>
              {value}
            </Text>
          )}
        </div>
      </div>
      {children}
    </div>
  )
}

export default LabelValue
